import React from "react"
import { HeroLead } from "trimble-terra"
import { navigate } from "gatsby"
import RichTextConnector from "../../../components/RichText/RichTextConnector"
import { formatThemePreset } from "../formatTheme"

const FormatAndRenderLeadHeroSearch = ({ data }) => {
  const {
    eyebrow,
    header,
    subheader,
    description,
    media,
    backgroundTheme,
    bottomTheme,
    isHeaderBig,
  } = data
  const backgroundThemePreset = formatThemePreset(backgroundTheme)
  const bottomThemePreset = formatThemePreset(bottomTheme)

  const formattedData = {
    eyebrow,
    header,
    subheader: subheader?.subheader,
    description: <RichTextConnector data={{ content: description }} />,
    presetTheme: backgroundThemePreset,
    isWrapped: true,
    isHeaderBig: isHeaderBig || false,
  }

  const content = (() => {
    if (media?.__typename === "ContentfulImageWithFocalPoint") {
      const backgroundImage = {
        title: media?.title,
        url: media?.image?.file?.url,
        x: media?.focalPoint?.focalPoint?.x,
        y: media?.focalPoint?.focalPoint?.y,
        height: media?.image?.file?.details?.image?.height,
        width: media?.image?.file?.details?.image?.width,
      }
      return {
        ...formattedData,
        backgroundImage,
        video: null,
      }
    } else if (media?.__typename === "ContentfulVideo") {
      const video = {
        title: media?.title,
        src: media?.videoUrl,
      }
      return {
        ...formattedData,
        backgroundImage: null,
        video,
      }
    }

    return formattedData
  })()

  const handleSearch = value => {
    navigate(`?search=${value}`, { replace: false })
  }

  return (
    <HeroLead
      isWrapped={true}
      presetTheme={bottomThemePreset}
      isSearchEnabled={true}
      searchPlaceholderText={data?.searchPlaceholderText}
      onSearch={handleSearch}
      content={[content]}
    />
  )
}

export default FormatAndRenderLeadHeroSearch
